import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getYearAccumulateList = async (params = {}) => {
  return await api.post("/v1/yearAccumulateCompany/getYearAccumulatePaging", params);
};

export const manageStatusYearAccumulate = async (params = {}) => {
  return await api.post(
    "/v1/yearAccumulateCompany/manageStatusYearAccumulate",
    params
  );
};

export const createYearAccumulateList = async (params = {}) => {
  return await api.post(
    "/v1/yearAccumulateCompany/createYearAccumulate",
    params
  );
};

export const updateYearAccumulateList = async (params = {}) => {
  return await api.post(
    "/v1/yearAccumulateCompany/updateYearAccumulate",
    params
  );
};

// export const getEmployee = async (params = {}) => {
//   return await api.post("/v1/employee/findAllEmployee", params);
// };

// export const getDropDown = async (params = {}) => {
//   return await api.post("/v1/dropdown/getEmployee", params);
// };
